import { memo } from 'react';
import { BaseEdge, EdgeProps, getBezierPath, EdgeLabelRenderer } from '@xyflow/react';
import { Button } from '@/components/ui/button';

export const JoinEdge = memo(({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}: EdgeProps) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const joinType = data?.joinType || 'INNER';

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: '#6366f1',
          strokeWidth: 2,
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
        >
          <Button
            size="sm"
            variant="secondary"
            className="text-xs px-3 py-1 h-auto font-semibold shadow-md border-2 bg-primary/10 hover:bg-primary/20 border-primary/20"
          >
            {joinType} JOIN
          </Button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
});

JoinEdge.displayName = 'JoinEdge';
